<template>
	<div>
		<div style="height: 80px;"></div>
		<div style="background: #F8F8F8; height: 30px;line-height: 30px;">
			<div class="container">
				首页 > 新闻中心 > 企业动态 > 文章详情
			</div>
		</div>
		<!-- 新闻内容 -->
		<div class="container">
			<div style="height:  15px;"></div>
			<div class="pcpadding" style="background-color: white;width: 100%;">
				<!-- 标题 -->
				<div style="color: #333333;font-weight: bold;font-size: 39px;line-height: 59px;">
					星链联合华为共同助力中国时尚产业数字化
				</div>
				<!-- 时间 -->
				<div style="height: 25px;"></div>
				<div class="context_tiem alibabapuhuiti_bold">
					2022-04-01
				</div>
				<div style="height: 35px;"></div>
				<!-- 新闻内容 -->
				<div class="context_tiem" style="text-indent: 2em;line-height :35px;letter-spacing:1px;">
					2022年1月7日上午，浙江星链数据科技有限公司与华为云计算技术有限公司在深圳华为总部签署了“AI数字时尚产业联合创新项目合作协议”，双方通过运用互联网、AI大数据、人工智能技术，基于华为云AI盘古大模型技术和星链C2M数字化产业解决方案，为传统产业提供数字化整体解决方案，助力时尚产业数字化发展，共同构建数字时尚产业互联网新生态。星链创始人兼CEO潘少宝、华为中国区政企副总裁陈斌，华为深圳政企解决方案部部长锁斐、华为产业云运营部部长刘宇鹏、华为云盘古大模型产品总监李寅博士等一同出席签约仪式，并参观了华为中国鲲鹏产业源头创新中心。
				</div>
				<img style="width: 100%;" src="../../static/news/4/1.png"></img>
				<div class="context_tiem" style="text-indent: 2em;line-height :35px;letter-spacing:1px;">
					据了解，本次星链与华为签约的联合创新项目，共建联合创新实验室，其核心价值在于为中国鞋服和箱包等时尚产业提供从“流行趋势数据挖掘、3D设计、数字化版权”到“数字化订货交易平台和柔性智能制造数控系统”全产业链的时尚产业数字化解决方案。通过AI数字时尚产业平台的构建，链接时尚产业上下游，将上游更多优质的鞋服和箱包等时尚产品，和更多的原创设计师、时尚买手、主播达人、MCN机构、品牌商以及跨境电商等新流量平台进行数字链接，通过网络协同效应，以数据需求驱动柔性供应链发展，最终实现以销定产、按需供应、柔性生产、快速响应的数字化产业生态模式。
				</div>
				<div class="context_tiem" style="text-indent: 2em;line-height :35px;letter-spacing:1px;">
					在签约仪式上，星链创始人兼CEO潘少宝表示：“时尚产业是国民经济中的大产业，过去以产定销、先产后卖、高库存、重资产的产业模式已不适应新经济发展需求。我们希望此次星链与华为共同构建的AI数字时尚产业平台和星链C2M数字化平台，能为温州乃至全国时尚产业提供“AI时尚趋势、数字研发、数字工厂、数字零售”的全产业链数字化服务，助力时尚产业从传统产业模式，走向以数据驱动的“个性化、小批量、多批次、快生产、云工厂”的数字化产业模式，让更多的企业享受数字经济红利。
				</div>
				<img style="width: 100%;" src="../../static/news/4/2.png"></img>
				<div class="context_tiem" style="text-indent: 2em;line-height :35px;letter-spacing:1px;">
					同时，华为中国区政企副总裁陈斌表示：“华为云专注于云计算中公有云领域的技术研究与生态拓展，致力于为用户提供一站式云计算基础设施服务。本次华为与星链的联合创新项目，是华为云在AI数字时尚产业领域的新服务，必将加快中国时尚产业数字化进程，实现万企上云、万厂上云的美好未来！”
				</div>
				<div class="context_tiem" style="text-indent: 2em;line-height :35px;letter-spacing:1px;">
					据了解，星链于2021年获得了6000万元人民币A轮5亿估值融资，同时还获得了中国鞋业头部企业A股上市公司奥康国际的战略投资。这也意味着星链的AI数字时尚经济模式同时得到了传统时尚产业和新兴资本的关注和认可，这次与华为的合作更是验证了星链C2M数字化战略的产业价值。也证明了我们温州本土企业完全有能力成长为行业中高精尖的数字化科技型企业。
				</div>
				<div class="context_tiem" style="text-indent: 2em;line-height :35px;letter-spacing:1px;">
					目前，星链的客户涵盖美国ROCKPORT（乐步）、
					PUMA（彪马）、SKECHERS（斯凯奇）等全球知名品牌，以及奥康等国内鞋业知名品牌。其中，星链还获得了国际品牌ROCKPORK（乐步）的全球设计研发生产授权，这也体现了星链作为一家创业初期的企业为国际化品牌提供数字化服务的水平和能力。
				</div>
				<div class="context_tiem" style="text-indent: 2em;line-height :35px;letter-spacing:1px;">
					星链CEO潘少宝还介绍了企业下一步战略规划：“我们计划于2022年6月份启动星链C2M数字化订货交易平台海外版，为全球的企业提供AI数字化时尚产业解决方案，服务更多的传统时尚企业。”
				</div>


				<div class="context_tiem" style="text-indent: 2em;line-height :35px;letter-spacing:1px;">
					国家的十四五计划指出，数字经济高质量快速发展是国家的重要战略，而温州作为拥有强大生产力的时尚产业之都，也在积极响应国家的号召。本次星链与华为的联合创新项目也意味着温州加速了时尚产业数字化的进程。
				</div>


				<!-- 新闻内容end -->


			</div>
			<div style="height:  45px;"></div>
		</div>
		<!-- 新闻内容 end -->


	</div>
</template>
<script>
	export default {
		name: 'Newdetails4',
		components: {


		},
		data() {
			return {

			}
		},

	}
</script>

<style>
	.context_tiem {
		color: #5D8299;
		size: 17px;
	}
	@media (min-width: 1000px) {
		.pcpadding {
			padding: 55px 200px 55px 200px;
		}
	}
</style>
